import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';

@Component({
  selector: 'custom-togle',
  templateUrl: './custom-togle.component.html',
  styleUrls: ['./custom-togle.component.scss']
})
export class CustomTogleComponent extends AppComponentBase implements OnChanges{

  @Input() value: boolean = false;
  @Input() disabled: boolean = false;
  @Output() toggleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  constructor(injector: Injector, private cdr: ChangeDetectorRef) {
    super(injector);
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && !changes['value'].firstChange) {
      this.cdr.detectChanges();
    }
  }

  toggle(): void {
    if (this.disabled == false) {
      this.value = !this.value;
      this.toggleChange.emit(this.value);
    }
  }

  resetToggle(): void {
    this.value = false;
  }
}
